import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';

import { DashboardModuleConstants } from "./dashboard-module.constants";
import { AppCommonModule } from "../common/app-common.module";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [
    CommonModule,
    AppCommonModule,
    SharedModule,
    RouterModule
  ],
  declarations: DashboardModuleConstants.MODULE_COMPONENTS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: DashboardModuleConstants.MODULE_COMPONENTS
})
export class DashboardModule { }



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-module.ts